import { getPublicEnv } from './env';
import { getBoolean } from './get.boolean';
export const getCommonPosthogSettings = () => {
    const posthogKey = getPublicEnv('POSTHOG_KEY');
    if (!posthogKey) {
        console.warn('PostHog key is not set... PostHog will not be initialized.');
    }
    const posthogConfig = {
        api_host: getPublicEnv('POSTHOG_HOST', '/api/ingest'),
        debug: getBoolean(getPublicEnv('POSTHOG_DEBUG', 'false')),
        ui_host: getPublicEnv('POSTHOG_UI_HOST', 'https://eu.posthog.com'),
    };
    return { posthogConfig, posthogKey };
};
